import usercenter from "@/plugins/axios/usercenter";
import request from "@/plugins/axios/request";

export function homeActivityQuery() {
    return request({
        url: "/homepage/homeActivityQuery",
        method: "post",
        data: { platform: "1" }
    });
}

export function selectfarnews() {
    return request({
        url: "/homepage/selectfarnews",
        method: "post",
        data: { platform: "1" }
    });
}

export function homebannerquery(data) {
    return request({
        url: "/homepage/homebannerquery",
        method: "post",
        data: data
    });
}

export function homeAction(data) {
    return request({
        url: "/homepage/homeAction",
        method: "post",
        data: data
    });
}
export function queryPrivacyPolicy() {
    return request({
        url: "/articlecontroller/queryPrivacyPolicy",
        method: "post"
    });
}

// 新闻查询
export function queryarticle(ruleForm) {
    return request({
        url: "/articlecontroller/queryarticle",
        method: "post",
        data: ruleForm
    });
}
export function querynewbyid(ruleForm) {
    return request({
        url: "/articlecontroller/querynewbyid",
        method: "post",
        data: ruleForm
    });
}

export function selectarticle(ruleForm) {
    return request({
        url: "/articlecontroller/selectarticle",
        method: "post",
        data: ruleForm
    });
}

export function querymaincontent(ruleForm) {
    return request({
        url: "/activity/querymaincontent",
        method: "post",
        data: ruleForm
    });
}
export function querycaption(ruleForm) {
    return request({
        url: "/basenetdistirctcontroller/querycaption",
        method: "post",
        data: ruleForm
    });
}
export function insertbussinessjoin(ruleForm) {
    return request({
        url: "/osbussinessjoincontroller/insertbussinessjoin",
        method: "post",
        data: ruleForm
    });
}
//开放区域
export function selectopenregion(ruleForm) {
    return request({
        url: "/osopenregion/selectopenregion",
        method: "post",
        data: ruleForm
    });
}
//常见问题
export function selectfaq(appInfo) {
    return request({
        url: "/help/selectfaq",
        method: "post",
        data: appInfo
    });
}
//获取会员中心用户信息
export function getHomeCenterUser(url) {
    return request({
        url: url,
        method: "get"
    });
}

export function findbytype(appInfo) {
    return request({
        url: "/sysDict/findbytype",
        method: "post",
        data: appInfo
    });
}
//文章统计数目
export function countaddarticle(appInfo) {
    return request({
        url: "/frontarticle/countaddarticle",
        method: "post",
        data: appInfo
    });
}

export function lougout(url,data) {
    return request({
        url:url,
        method: "post",
        data:data
    });
}
export function getUserInfo(url) {
    return usercenter({
        url: url + "&v=" + Math.random(10),
        // url: url,
        method: "get"
    });
}
export function logoutUsercenter(url) {
    return usercenter({
        url: url,
        method: "get"
    });
}
export function test111() {
    return request({
        url: "/homepage/test111",
        method: "get"
    });
}
